module.exports = __webpack_public_path__ + "static/media/Niveau_elN11_3_249288.9515f237.png";